import Api from './api';

const BASE = '/called-tasks';

export const getByCalled = async (calledId) => {
  try {
    const result = await Api.get(`${BASE}/bycalled/${calledId}`);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false };
  }
};

export const ensure = async (calledId) => {
  try {
    const result = await Api.post(`${BASE}/ensure/${calledId}`);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false };
  }
};

export const create = async (payload) => {
  try {
    const result = await Api.post(BASE, payload);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false };
  }
};

export const complete = async (id, payload) => {
  try {
    const result = await Api.put(`${BASE}/${id}/complete`, payload);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false };
  }
};

export const reopen = async (id) => {
  try {
    const result = await Api.put(`${BASE}/${id}/reopen`);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false };
  }
};

export const deleteById = async (id) => {
  try {
    await Api.delete(`${BASE}/${id}`);
    return { success: true };
  } catch (err) {
    return { success: false };
  }
};

export const checkRequiredTasks = async (calledId) => {
  try {
    const result = await Api.get(`${BASE}/${calledId}/required-check`);
    if (result.data?.success) return result.data.data;
    return { blocked: false, incompleteTasks: [] };
  } catch {
    return { blocked: false, incompleteTasks: [] };
  }
};

export const updateTask = async (id, payload) => {
  try {
    const result = await Api.put(`${BASE}/${id}`, payload);
    if (result.data?.success) return { success: true, data: result.data.data };
    return { success: false };
  } catch {
    return { success: false };
  }
};

export const getTaskAttachments = async (taskId) => {
  try {
    const result = await Api.get(`${BASE}/${taskId}/attachments`);
    return { success: true, data: result.data.data };
  } catch {
    return { success: false, data: [] };
  }
};

export const updateCompletionText = async (id, completionText) => {
  try {
    await Api.patch(`${BASE}/${id}/completion-text`, { completionText });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const reorder = async (items) => {
  try {
    await Api.put(`${BASE}/reorder`, items);
    return { success: true };
  } catch {
    return { success: false };
  }
};
